import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { registerGlobalErrorHandlers } from './shared/services/errorLogService';

registerGlobalErrorHandlers();

const portal = process.env.REACT_APP_PORTAL;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

if (portal === 'admin') {
  import('./admin/AdminApp').then(({ default: AdminApp }) => {
    root.render(
      <React.StrictMode>
        <AdminApp />
      </React.StrictMode>
    );
  });
} else if (portal === 'practice') {
  import('./practice/PracticeApp').then(({ default: PracticeApp }) => {
    root.render(
      <React.StrictMode>
        <PracticeApp />
      </React.StrictMode>
    );
  });
} else {
  // Default: legacy App (backward compatible)
  import('./App').then(({ default: App }) => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });
}
